/**
 * Semantic Layout Tokens — CSS variable references, breakpoints, and media query helpers.
 */

import { breakpointValues, componentBreakpointValues } from "../primitives/layout";

export const layout = {
  navBarWidth: "var(--lay-navBarWidth)",
  navBarExpandedWidth: "var(--lay-navBarExpandedWidth)",
  pageMargin: "var(--lay-pageMargin)",
  vizPadding: "var(--lay-vizPadding)",
  controlsHeight: "var(--lay-controlsHeight)",
  menuMaxHeight: "var(--lay-menuMaxHeight)",
} as const;

export const breakpoints = {
  xxs: `${breakpointValues.xxs}px`,
  xs: `${breakpointValues.xs}px`,
  sm: `${breakpointValues.sm}px`,
  md: `${breakpointValues.md}px`,
  lg: `${breakpointValues.lg}px`,
  xxl: `${breakpointValues.xxl}px`,
  // Component-specific
  headerMobile: `${componentBreakpointValues.headerMobile}px`,
  tableCompact: `${componentBreakpointValues.tableCompact}px`,
} as const;

/** Media query helpers — use with Emotion template literals */
export const mediaAbove = (bp: keyof typeof breakpoints) =>
  `@media (min-width: ${breakpoints[bp]})`;
export const mediaBelow = (bp: keyof typeof breakpoints) =>
  `@media (max-width: ${breakpoints[bp]})`;
